// extracted by mini-css-extract-plugin
export const root = "fullscreen-image-viewer-module--root--2pIcU";
export const openButton = "fullscreen-image-viewer-module--openButton--1JWaT";
export const imageContainer = "fullscreen-image-viewer-module--imageContainer--FEDiS";
export const button = "fullscreen-image-viewer-module--button--8GDgq";